<template>
  <div>
    <template v-if="selectedBot.line_my_shop_is_active">
      <h3>{{ $t('เลือกแหล่งที่มาของสินค้า') }}</h3>
      <v-radio-group
        @change="selectProductBy"
        color="primary"
        v-model="dataProductBy"
        row
        class="text-xs-center mb-3"
      >
        <v-radio color="primary" :label="$t('ระบบ Zwiz')" :value="'zwiz'"></v-radio>
        <v-radio color="primary" :label="$t('LINE SHOPPING')" :value="'lineMyShop'"></v-radio>
      </v-radio-group>
    </template>
    <h3>{{ $t('เลือกรูปแบบการแสดงสินค้า') }}</h3>
    <v-radio-group color="primary" v-model="productShowType" col class="text-xs-center mb-3">
      <v-radio
        :class="productShowType === 'categories' ? 'mt-2' : ''"
        color="primary"
        :label="$t('แสดงสินค้ารายชิ้น')"
        :value="'product'"
      ></v-radio>
      <v-radio
        v-if="dataProductBy == 'lineMyShop'"
        color="primary"
        :label="$t('แสดงสินค้าทั้งหมด')"
        :value="'all'"
      ></v-radio>
      <v-radio v-if="dataProductBy !== 'lineMyShop'" color="primary" :value="'categories'">
        <template slot="label">
          <span> {{ $t('แสดงหมวดหมู่ ของสินค้า') }}</span>
        </template></v-radio
      >
      <multiselect
        class="shot"
        v-if="productShowType === 'categories'"
        :disabled="productShowType !== 'categories'"
        v-model="selectedCategory"
        :options="categoryOptions"
        label="label"
        selectLabel
        selectedLabel
        :allow-empty="false"
        :searchable="false"
        deselect-label
        track-by="label"
      ></multiselect>
    </v-radio-group>
    <template v-if="productShowType === 'product'">
      <generic-product
        :key="dataProductBy"
        v-model="value"
        :categories="categories"
        :currentCategory.sync="currentCategorys"
        :filterBadge="filterBadge"
        :pageCount="pageCount"
        :pageNumber.sync="pageNumber"
        :filterProducts="filterProducts"
        :search.sync="searchInput"
        :loadingProduct="loadingProduct"
        @onClickPagination="onClickPagination"
        @onSelectProduct="onSelectProduct"
        @closeDialog="closeDialog"
      ></generic-product>
    </template>
    <template v-else>
      <!-- <h3>{{ $t('เลือกไฟล์รูปของแค็ตตาล็อกสินค้า') }}</h3>
      <div class="form-control" :class="{ 'has-error': errors.has('image_url') }">
        <label>{{ $t('photo') }}</label>
        <uploadfile
          name="image_url"
          :data-vv-as="$t('photo')"
          v-model="genericData.image_url"
          :height="150"
          :backGroundAuto="true"
        ></uploadfile>
        <span class="text-error" v-if="errors.has('image_url')">{{
          errors.first('image_url')
        }}</span>
      </div>
      <form>
        <v-layout row wrap>
          <v-flex xs12 class="form-control pa-1">
            <label for>{{ $t('ตั้งชื่อหัวข้อ') }}</label>
            <div class="form-inline form-control" :class="{ 'has-error': errors.has('title') }">
              <input
                maxlength="80"
                type="text"
                class="form-control"
                name="title"
                data-vv-name="title"
                :data-vv-as="$t('title')"
                :placeholder="$t('title')"
                v-model.lazy="genericData.title"
              />

              <p class="text-error" v-if="errors.has('title')">
                {{ errors.first('title') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="form-control pa-1">
            <label for>{{ $t('ใส่รายละเอียดย่อย') }}</label>
            <div class="form-inline form-control" :class="{ 'has-error': errors.has('subtitle') }">
              <input
                maxlength="80"
                type="text"
                class="form-control"
                name="subtitle"
                data-vv-name="subtitle"
                :data-vv-as="$t('subtitle')"
                :placeholder="$t('subtitle')"
                v-model.lazy="genericData.subtitle"
              />

              <p class="text-error" v-if="errors.has('subtitle')">
                {{ errors.first('subtitle') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="form-control pa-1">
            <label for>{{ $t('ตั้งค่าชื่อปุ่ม') }}</label>
            <div class="form-inline form-control" :class="{ 'has-error': errors.has('button name') }">
              <input
                maxlength="20"
                type="text"
                class="form-control"
                name="button name"
                data-vv-name="button name"
                :data-vv-as="$t('button name')"
                :placeholder="$t('button name')"
                v-model.lazy="btnName"
              />

              <p class="text-error" v-if="errors.has('button name')">
                {{ errors.first('button name') }}
              </p>
            </div>
          </v-flex>
        </v-layout> -->
      <div class="text-xs-center">
        <v-btn class="mt-2" small depressed color="primary" @click="onSave">{{ $t('Save') }}</v-btn>
      </div>

      <!-- </form> -->
    </template>
  </div>
</template>

<script>
import GenericProduct from './GenericProduct'
import uploadfile from '@/components/elements/uploadfile'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: false
    },
    productBy: {
      default: 'zwiz'
    },
    filterProducts: {
      default: null
    },
    search: {
      default: null
    },
    categories: {
      default: null
    },
    currentCategory: {
      default: null
    },
    filterBadge: {
      default: null
    },
    generic: {
      default: null
    },
    pageCount: { default: 0 },
    pageNumber: { default: 0 },
    loadingProduct: { default: false }
  },
  components: {
    Multiselect,
    GenericProduct,
    uploadfile
  },
  data: function() {
    return {
      selectedCategory: {
        label: 'All',
        value: 'all'
      },
      currentCategorys: this.currentCategory,
      searchInput: this.search,
      productShowType: 'product',
      dataForm: {},
      genericData: this.generic,
      dataProductBy: 'zwiz',
      btnName: 'รายละเอียดสินค้า'
    }
  },
  async mounted() {
    if (this.generic && this.generic.buttons && this.generic.buttons.length > 0) {
      var category = this.generic.buttons[0].url.split('&category=')[1]

      this.selectedCategory = await this.categoryOptions.filter(
        item => item.value.toString() === category
      )[0]
      this.productShowType = 'categories'
      this.btnName = this.generic.buttons[0].title
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    categoryOptions: function() {
      var categories = [
        {
          label: 'All',
          value: 'all'
        },
        {
          label: 'Sales',
          value: 'sales'
        }
      ]
      if (this.categories) {
        this.categories.map(function(category) {
          categories.push({ label: category.name, value: category.id })
        })
      }
      return categories
    }
  },
  watch: {
    currentCategorys(newVal, oldVal) {
      if (newVal != oldVal) {
        const vm = this
        vm.$emit('update:currentCategory', newVal)
      }
    },
    searchInput(newVal, oldVal) {
      if (newVal != oldVal) {
        const vm = this
        vm.$emit('update:search', newVal)
      }
    }
  },
  methods: {
    selectProductBy() {
      const vm = this
      vm.productShowType = 'product'
      vm.$emit('selectProductBy', vm.dataProductBy)
      vm.$emit('onClickPagination', 1)
    },
    onSave() {
      const vm = this
      let url = ''
      if (vm.dataProductBy === 'lineMyShop') {
        url = `${vm.selectedBot.line_my_shop_liff_shop_url}`
        if (vm.productShowType === 'all') {
          vm.genericData.title = 'LINE Shopping'
          vm.genericData.subtitle = ''
          vm.genericData.image_url = null
        }
      } else {
        if (vm.productShowType === 'categories') {
          url = `{shopurl}&category=${vm.selectedCategory.value}`
          vm.genericData.title = vm.selectedCategory.label
          vm.genericData.image_url = null
          vm.genericData.subtitle = ''
        }
      }

      if (vm.btnName) {
        vm.genericData.buttons[0] = {
          title: vm.btnName,
          type: 'web_url',
          url: url
        }
      }
      vm.$emit('update:generic', vm.genericData)
      vm.$emit('onSave')
    },
    closeDialog() {
      const vm = this
      vm.$emit('closeDialog')
    },
    onSelectProduct(product) {
      const vm = this
      vm.$emit('onSelectProduct', product)
    },
    onClickPagination(pageNumber) {
      const vm = this
      vm.$emit('onClickPagination', pageNumber)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/GenericLineProduct.vue